import { ref, computed, watch } from '@vue/composition-api';

export function useLazyComputed (computedFn, condition) {
  const tempComputed = computed(computedFn);
  const internalValue = ref(tempComputed.value);
  watch(() => tempComputed.value, (...args) => {
    if (condition(...args)) internalValue.value = tempComputed.value;
  });
  return internalValue;
}
